@if (!submitted) {
  <layout-sidebar>
    <div class="main">
      <app-contact-adjuster-form
        [party]="party"
        [customer]="customer"
        (contactInfo)="handleContactInfo($event)"
        [contactAdjusterSummary]="componentData.contactAdjusterSummary"
        [contactAdjusterCommentHeader]="componentData.contactAdjusterCommentHeader"
        [contactAdjusterEmailHeader]="componentData.contactAdjusterEmailHeader"
      >
      </app-contact-adjuster-form>
    </div>
    <aside class="main-aside">
      <ds-quick-links-list [links]="quickLinksList"></ds-quick-links-list>
    </aside>
  </layout-sidebar>
}

@if (submitted) {
  <app-contact-adjuster-confirmation
    [contactInfo]="contactInfo"
    [contactAdjusterConfirmationHeader]="componentData.contactAdjusterConfirmationHeader"
  >
  </app-contact-adjuster-confirmation>
}
